import { render, staticRenderFns } from "./navigate-to.vue?vue&type=template&id=3da0af56"
import script from "./navigate-to.vue?vue&type=script&lang=js"
export * from "./navigate-to.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports